<template>
    <div>
      <el-mention
        v-model="comment"
        type="textarea"
        :options="options"
        style="width: 100%"
        placeholder="Please input"
      />

      <el-button type="primary" @click="saveComment" style="margin-top: 10px;">
        Save
      </el-button>

      <!-- Timeline para exibir os comentários -->
      <el-timeline style="margin-top: 20px;">
        <el-timeline-item
          v-for="(comment, index) in comments"
          :key="index"
          :timestamp="formatDate(comment.created_at)"
          placement="top"
          icon="ChatDotRound"
          type="primary"
        >
          <el-card>
            <p>{{ comment.commment }}</p>
            <p><strong>By:</strong> {{ comment.user }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
</template>
  
<script>
import { getComment, storeComments } from '@/services/taskService';
import { mapGetters } from 'vuex';

  
export default {
  props: {
    taskId: Number,
  },
  data() {
    return {
      comment: '',
      options: [],
      comments: []
    };
  },
  async created() {      
    this.users();
    this.loadComments();    
  },
  methods: {
    users() {
      this.options = this.activeUsers.map((item) => {
        return { 
          label: item.name, 
          value: item.name 
        };        
      });      
    },

    async saveComment() {
      if (!this.comment.trim()) {
        this.$message({
          message: 'Comment cannot be empty',
          type: 'warning'
        });
        return;
      }

      try {

        const response = await storeComments({
          tasks_id: this.taskId,
          comment: this.comment
        });

        if (response) {
          this.$message({
            message: 'Comentário salvo com sucesso',
            type: 'success'
          });
          this.comment = '';
          this.loadComments();
        }

      } catch (error) {
        this.$message({
          message: 'An error occurred while saving the comment',
          type: 'error'
        });
        console.error(error);
      }
    },

    async loadComments() {
      try {
        const response = await getComment(this.taskId);
        
          this.comments = response.data;

      } catch (error) {
        this.$message({
          message: 'Failed to load comments',
          type: 'error'
        });
        console.error(error);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString(); // Formata a data para um formato legível
    }
  },
  computed: {        
      ...mapGetters('taskData', [          
          'activeUsers'    
      ])
  },

};
</script>
